<template>
    <div class="static-map-wrapper">
        <img class="static-map" :src="src">
    </div>
</template>

<script>
export default {
    props: ["attributes"],
    data () {
        return {
            username: 'chachopazos',
            style: "cisk2sggc004d2wnvjy0rxc8m",
            accessToken: 'pk.eyJ1IjoiY2hhY2hvcGF6b3MiLCJhIjoiY2pkMDN3eW4wNHkwZDJ5bGc0cnpueGNxbCJ9.WWWg_OnK5e7L1RknMliY4A',
            zoom: 14,
            width: 700,
            height: 500,
        }
    },
    computed: {
        lat (){
            return this.attributes.value.lat
        },
        long (){
            return this.attributes.value.long
        },
        src (){
            return `https://api.mapbox.com/styles/v1/${this.username}/${this.style}/static/${this.long},${this.lat},${this.zoom},0.00,0/${this.width}x${this.height}@2x?access_token=${this.accessToken}`
        } 
    }
}
</script>

<style lang="scss" scoped>
.static-map-wrapper {
    position: relative;

    img {
        display: block;
        max-width: 700px;
        height: 500px;
        width: 100%;
        margin: 0 auto;
        object-fit: cover;
        clip-path: inset(5% 0% 5% 0%);
    }

    &:after {
        content: "";
        position: absolute;
        bottom: 50%;
        left: 50%;
        width: 40px;
        height: 40px;
        transform: translate(-50%, 0%);
        z-index: 10;
        background: url(~images/project/icons/location.svg) no-repeat;
    }
}
</style>